module.exports = __webpack_public_path__ + "assets/img/jingshi--blue.3bb9df36.png";